import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';

@Component({
  selector: 'app-formly-item-attribute-tree',
  templateUrl: './formly-label.component.html',
  styleUrls: ['./formly-label.component.scss'],
  standalone: true,
})
export class FormlyLabelComponent extends FieldType<any> {}
